export const severityLabels = {
  CRITICAL: "Kritisch",
  MAJOR: "Hoher Schweregrad",
  MINOR: "Geringer Schweregrad",
  WARNING: "Warnung",
  INDETERMINATE: "Schweregrad unbestimmt",
};

export const statusLabels = {
  ACTIVE_UNACK: "✎ Aktiv (unbestätigt)",
  ACTIVE_ACK: "✎ Aktiv (bestätigt)",
  CLEARED_ACK: "Behoben",
};

export const severityOrder = {
  CRITICAL: 0,
  MAJOR: 1,
  MINOR: 2,
  WARNING: 3,
  INDETERMINATE: 4,
};

export const statusOrder = {
  ACTIVE_UNACK: 0,
  ACTIVE_ACK: 1,
  CLEARED_ACK: 2,
};

export const SEVERITY_OPTIONS = [
  { value: 'CRITICAL', label: 'Kritisch' },
  { value: 'MAJOR', label: 'Hoch' },
  { value: 'MINOR', label: 'Niedrig' },
  { value: 'WARNING', label: 'Warnung' },
  { value: 'INDETERMINATE', label: 'Unbestimmt' },
];

export const entityTypeLabels = {
  DEVICE: "Endgerät",
  DEVICE_PROFILE: "Endgerätetyp",
  ASSET: "Asset",
  ASSET_PROFILE: "Asset-Typ",
};

export function getSeverities(rule) {
  return Object.keys(rule?.configuration?.createRules || {});
}
